import { extractTextFromQuery } from '../../../utils/query';
import { activity_name_$ilike_includes } from '../../../utils/query-helpers';

export default {
  param: extractTextFromQuery,
  having: function (text) {
    const words = text.trim().split(' ');

    if (text) {
      return {
        $or: words.map(function(word) {
          return {
            title: {
              $ilike: `%${word}%`
            }
          };
        }).concat(words.map(function(word) {
          return {
            ...activity_name_$ilike_includes(word)
          };
        }))
      }
    }
  }
}
